import attackFile2 from "@assets/pdf/200521_TH_นโยบายความเป็นส่วนตัวสำหรับคู่ธุรกิจและผู้ที่เกี่ยวข้อง_PKG_V1.2.pdf";
import attackFile3 from "@assets/pdf/200521_TH_นโยบายความเป็นส่วนตัวสำหรับผู้เข้าร่วมกิจกรรมหรือผู้เข้ามาติดต่อ_PKG_V1.2.pdf";
import attackFile4 from "@assets/pdf/200521_TH_นโยบายความเป็นส่วนตัวสำหรับผู้ถือหุ้น_ผู้ถือหุ้นกู้_และกรรมการ_PKG_V1.2.pdf";
import attackFile1 from "@assets/pdf/200521_TH_นโยบายความเป็นส่วนตัวสำหรับลูกค้า_PKG_V1.2.pdf";
import { Box, Button, Typography } from "@material-ui/core";
import Container from "@saleor/components/Container";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";
// import { Link } from "react-router-dom";

const useStyles = makeStyles(
  theme => ({
    policyCardWrapepr: {
      background: "#FFFFFF",
      textAlign: "center",
      padding: "32px 142px 72px",
      borderRadius: 8
    },
    title: {
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        padding: 0
      },
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      webkitBackgroundClip: "text",
      webkitTextFillColor: "transparent",
      backgroundClip: "text",
      textFillColor: "transparent",
      fontWeight: 700,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    },
    titleDescription: {
      fontSize: 20,
      margin: 24
    },
    policyItem: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      padding: "16px 32px",
      borderBottom: "2px solid #E0E0E0",
      justifyContent: "space-between",
      "& .policy-item__text": {
        fontSize: 18,
        color: "#555555"
      },
      "& button": {
        width: "160px",
        height: "40px",
        fontSize: 16,
        color: "#FFFFFF"
      }
    }
  }),
  { name: "PrivacyPolicy" }
);

const PrivacyPolicy = () => {
  const classes = useStyles();
  const intl = useIntl();
  // const navigate = useNavigator();

  const policies = [
    {
      text: intl.formatMessage({
        defaultMessage: "นโยบายความเป็นส่วนตัวสำหรับลูกค้า"
      }),
      link: attackFile1
    },

    {
      text: intl.formatMessage({
        defaultMessage: "นโยบายความเป็นส่วนตัวสำหรับคู่ธุรกิจและผู้เกี่ยวข้อง"
      }),
      link: attackFile2
    },

    {
      text: intl.formatMessage({
        defaultMessage:
          "นโยบายความเป็นส่วนตัวสำหรับผู้เข้าร่วมกิจกรรมหรือผู้มาเข้าติดต่อ"
      }),
      link: attackFile3
    },
    {
      text: intl.formatMessage({
        defaultMessage:
          "นโยบายความเป็นส่วนตัวสำหรับผู้ถือหุ้น ผู้ถือหุ้นกู้ และกรรมการ"
      }),
      link: attackFile4
    }
  ];

  return (
    <Container>
      <Box className={classes.policyCardWrapepr}>
        <Typography className={classes.title} variant="h3">
          {intl.formatMessage({
            defaultMessage: "PRIVACY POLICY"
          })}
        </Typography>
        <Box className={classes.titleDescription}>
          <MyTypography variant="h7">
            {intl.formatMessage({
              defaultMessage: "นโยบายความเป็นส่วนตัว"
            })}
          </MyTypography>
        </Box>
        <Box>
          {policies.map((policy, index) => (
            <Box className={classes.policyItem} key={index}>
              <Typography className="policy-item__text">
                {policy.text}
              </Typography>
              <Button
                onClick={() => {
                  window.open(`${policy.link}`, "_blank", "noopener");
                }}
                variant="contained"
                color="secondary"
              >
                {intl.formatMessage({
                  defaultMessage: "ดูรายละเอียด"
                })}
              </Button>
            </Box>
          ))}
        </Box>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;
